const firebaseConfig = {
    apiKey: 'AIzaSyDQ859XpIWuA3cbYBRFze_V41E-YDW8InA',
    authDomain: 'fir-practice-project-f69f3.firebaseapp.com',
    projectId: 'fir-practice-project-f69f3',
    storageBucket: 'fir-practice-project-f69f3.appspot.com',
    messagingSenderId: '10969648078',
    appId: '1:10969648078:web:15bffe60c76560901a799f',
};
export default firebaseConfig;
